import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import Login from './Components/Login'
import Dashboard from './Components/Dashboard';
import AllCards from './Components/AllCards';
import GamePage from './Components/GamePage';
import Report from './Components/Reports';
import AdminTable from './Components/AllStats';
import Keriti from './Components/Keriti';
import MultiplierBingoPage from './Components/MultiplierBingoPage';
import GamePage2 from './Components/GamePage2';
import MultiplierBingoStats from './Components/MultiplierBingoStats';
import BlockedPage from './Components/Blocked';
import Morzan from './Components/Morzan';

function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/all-cards" element={<AllCards />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/game-in-progress" element={ <GamePage />} />
        <Route path="/reports" element={ <Report />} />
        <Route path="/final/warning/matiwos/tsegaye/shewa/robit/meresat/ale/" element={ <AdminTable />} />
        <Route path="/multiplier" element={ <Dashboard />} />
        <Route path="/blocked" element={<BlockedPage />} />
        <Route path="/game-in-progress2" element={<GamePage2 />} />
        <Route path="/shashemene" element={<Keriti />} />
        <Route path="/abazh" element={<MultiplierBingoPage />} />
        <Route path="/multiplierStats" element={<MultiplierBingoStats />} />
        <Route path="/hawassa" element={<Morzan />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;